import { Component } from '@poa/core';
import { Observer } from '@poa/state';
import React from 'react';
import DataTable from '../components/data-table/data-table';
import Navbar from '../components/navbar';
import RouteLoading from '../components/route-loading';
import TableFilter from '../components/table-filter';
import Dropdown from '../components/dropdown';
import cx from 'classnames';

class GiftsPage extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa
  env; // injected by Poa

  render() {
    const { filters, selectors } = this.store.gifts;
    const { changeGrouping, changeFilter } = this.actions.giftsActions;

    return (
      <RouteLoading
        meta={this.store.gifts.meta}
        render={() => (
          <div className="content">
            <Navbar />
            <TableFilter
              state={filters}
              selectors={selectors}
              onGroupingChange={changeGrouping}
              withoutFractionalChange
              withoutFilteringChange
              withoutStatusChange
              withoutDatesChange
              withSearch={false}
              withColumnsConfigure={false}
              getTableNode={() => this.node}
              render={() => {
                return (
                  <Dropdown label={this.t('filters')} selected={<span>{filters.filter}</span>}>
                    <button
                      className={cx([
                        'common-filter__btn',
                        { 'is-active': filters.filter === 'all' }
                      ])}
                      onClick={() => changeFilter('all')}
                    >
                      all
                    </button>
                    <button
                      className={cx([
                        'common-filter__btn',
                        { 'is-active': filters.filter === 'archive' }
                      ])}
                      onClick={() => changeFilter('archive')}
                    >
                      archive
                    </button>
                    <button
                      className={cx([
                        'common-filter__btn',
                        { 'is-active': filters.filter === 'actual' }
                      ])}
                      onClick={() => changeFilter('actual')}
                    >
                      actual
                    </button>
                  </Dropdown>
                );
              }}
            />
            <div className="container finances-container small-container">
              <div className="inner">
                <div className="inner-scroll finances-table">
                  <Observer>
                    {() =>
                      selectors.filteredData.map((table, idx) => (
                        <DataTable
                          ref={node => (this.node = node)}
                          sticky={true}
                          tableFiltersKey="gifts-filters"
                          key={idx}
                          data={table}
                          columnSettings={filters.columnSettings}
                          selectors={selectors}
                          toNumberKeys={['panel']}
                          initialSortingMap={{ panel: 'asc' }}
                          account_filters={null}
                        />
                      ))
                    }
                  </Observer>
                </div>
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

export default Component({ namespaces: ['gifts'] })(GiftsPage);
